import React from "react";
import { Phone, MapPin, ShieldCheck } from "lucide-react";
import { useStore } from "@/store/StoreContext";

export default function Footer() {
  const { content } = useStore();
  return (
    <footer data-testid="footer" className="relative border-t border-[#D4AF37]/25 bg-[#1C130B]">
      <div className="gold-rule w-full" />
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/assets/brand/logo.png" alt="Rudralife" className="mb-5 h-10 w-auto brightness-0 invert" />
          <p className="text-sm leading-relaxed text-[#D8C9AC]">
            Welcome to the world of highest-quality Rudraksha. For 25 years, Rudralife has guided seekers with authentic, lab-certified Rudraksha and Vedic wisdom.
          </p>
        </div>
        <div>
          <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.26em] text-[#D4AF37]">Shop</h3>
          <ul className="space-y-3 text-sm text-[#D8C9AC]">
            <li><a data-testid="footer-link-collection" href="#collection" className="transition-colors hover:text-[#F3E5AB]">Diwali Collection</a></li>
            <li><a data-testid="footer-link-featured" href="#featured" className="transition-colors hover:text-[#F3E5AB]">Featured Products</a></li>
            <li><a href="https://rudralife.com/rudraksha-recommendation/" target="_blank" rel="noreferrer" className="transition-colors hover:text-[#F3E5AB]">Rudraksha Recommendation</a></li>
            <li><a href="https://rudralife.com/exhibition" target="_blank" rel="noreferrer" className="transition-colors hover:text-[#F3E5AB]">Exhibitions</a></li>
          </ul>
        </div>
        <div>
          <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.26em] text-[#D4AF37]">Rudralife</h3>
          <ul className="space-y-3 text-sm text-[#D8C9AC]">
            <li><a data-testid="footer-link-anniversary" href="#anniversary" className="transition-colors hover:text-[#F3E5AB]">25th Anniversary</a></li>
            <li><a data-testid="footer-link-celebrities" href="#celebrities" className="transition-colors hover:text-[#F3E5AB]">Celebrities</a></li>
            <li><a href="https://rudralife.com/terms-and-conditions" target="_blank" rel="noreferrer" className="transition-colors hover:text-[#F3E5AB]">Terms & Conditions</a></li>
            <li><a href="https://rudralife.com/privacy-policy" target="_blank" rel="noreferrer" className="transition-colors hover:text-[#F3E5AB]">Privacy Policy</a></li>
            <li><a data-testid="footer-admin-link" href="/admin" className="transition-colors hover:text-[#F3E5AB]">Admin Login</a></li>
          </ul>
        </div>
        <div>
          <h3 className="mb-5 text-xs font-bold uppercase tracking-[0.26em] text-[#D4AF37]">Contact</h3>
          <ul className="space-y-4 text-sm text-[#D8C9AC]">
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />
              <a data-testid="footer-phone" href={`tel:${(content?.contact_phone || "").replace(/[^+\d]/g, "")}`} className="transition-colors hover:text-[#F3E5AB]">
                {content?.contact_phone || "+91-72088 19922"}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />
              <span>{content?.contact_address || "Rudralife Head Office, 901, Sri Krishna, New Link Road, Andheri (West), Mumbai - 400 053"}</span>
            </li>
            <li className="flex items-start gap-3">
              <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-[#D4AF37]" />
              <span>Secure payments via Razorpay · Cards, UPI, NetBanking, Wallets</span>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#D4AF37]/15 py-6 text-center text-xs tracking-wide text-[#D8C9AC]/70">
        © 2026 Rudralife. All rights reserved. · Free shipping across India · $40 international delivery
      </div>
    </footer>
  );
}
